import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { Mail, ArrowLeft } from "lucide-react";

const EMAILS = [
  {
    address: "hello@resynote.com",
    label: "Product, support & feedback",
  },
];

export default function Contact() {
  return (
    <div className="min-h-screen bg-white dark:bg-zinc-950 text-zinc-900 dark:text-zinc-100" data-testid="contact-page">
      {/* Top bar */}
      <header className="border-b border-zinc-200 dark:border-zinc-800">
        <div className="max-w-5xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="contact-home-link">
            <Logo size={28} />
            <span className="font-sans font-bold tracking-tight text-lg">
              Resy<span className="text-blue-600">Note</span>
            </span>
          </Link>
          <Link to="/" className="text-xs font-mono text-zinc-500 hover:text-zinc-900 dark:hover:text-zinc-50 flex items-center gap-1.5">
            <ArrowLeft className="h-3.5 w-3.5" /> Back home
          </Link>
        </div>
      </header>

      <section className="max-w-3xl mx-auto px-6 py-16 md:py-24 space-y-10">
        <div>
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-blue-600">Get in touch</div>
          <h1 className="text-4xl sm:text-5xl font-sans font-bold tracking-tight mt-2">
            Contact us
          </h1>
          <p className="mt-4 text-base font-body text-zinc-600 dark:text-zinc-400 leading-relaxed">
            Questions, feedback, or partnership ideas? We read every email and usually reply within one business day.
          </p>
        </div>

        <div className="max-w-md">
          {EMAILS.map((e) => (
            <a
              key={e.address}
              href={`mailto:${e.address}`}
              className="group block rounded-lg border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 p-6 hover:border-blue-500/60 hover:shadow-sm transition-all"
              data-testid={`contact-email-${e.address}`}
            >
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 rounded-md bg-blue-50 dark:bg-blue-950/40 grid place-items-center text-blue-600">
                  <Mail className="h-5 w-5" />
                </div>
                <div className="min-w-0">
                  <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500">
                    {e.label}
                  </div>
                  <div className="font-sans font-semibold text-base mt-0.5 break-all group-hover:text-blue-600 transition-colors">
                    {e.address}
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="rounded-lg border border-zinc-200 dark:border-zinc-800 bg-zinc-50 dark:bg-zinc-900/50 p-6">
          <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500">
            Company
          </div>
          <div className="font-sans font-semibold mt-1">THREENNOVATORS LLP</div>
          <div className="text-sm font-body text-zinc-600 dark:text-zinc-400 mt-2">
            Owner & operator of ResyNote.
          </div>
        </div>

        <div className="flex flex-wrap gap-4 text-xs font-mono text-zinc-500 pt-4 border-t border-zinc-200 dark:border-zinc-800">
          <Link to="/terms" className="hover:text-zinc-900 dark:hover:text-zinc-50" data-testid="link-terms">Terms & Conditions</Link>
          <span>·</span>
          <Link to="/refund-policy" className="hover:text-zinc-900 dark:hover:text-zinc-50" data-testid="link-refund">Refund Policy</Link>
        </div>
      </section>
    </div>
  );
}
